var Gtm = {
    CURRENCY: 'TR',
    PAGE_TYPE: 'account',
    OTHER_PAGE_TYPE: 'other',
    PURCHASE_PAGE_TYPE: 'purchase',
    CITY_INFO: 'ISTANBUL-AVRUPA',
    DEFAULT_PAGE_TITLE: 'Cicek Siparisi, Online Cicek Gonder , CicekSepeti.com'
};
export default Gtm;
